import { t } from '../../../i18next';
import { postRequest } from '../../../shared/utils';
async function CommitHandler(props) {
  const {
    addedRow,
    editedRow,
    editedRowOriginal,
    tableDetails: { id },
    userDetails,
    configSchema,
    deletedRow,
  } = props;

  const resultSet = {
    success: true,
    errors: [],
  };

  const addedRecord = addedRow.reduce((resp, item) => {
    const { user_account_id: userId, role_id: roleIds } = item;
    const newRows = roleIds.map((roleId) => ({
      user_id: userId,
      role_id: roleId,
      created_by: userDetails.userId,
      updated_by: userDetails.userId,
      update_date: new Date().toISOString().substring(0, 19),
    }));
    if (newRows.length) {
      resp = resp.concat(newRows);
    }
    return resp;
  }, []);

  const userToRoleIds = deletedRow.map((item) => item.user_to_role_id);
  const idsForUserToRoles = userToRoleIds.flatMap((arr) =>
    arr.map((obj) => Object.values(obj)).flat(),
  );

  const editedRecord = getEditedRowLogic({ editedRow, editedRowOriginal, userDetails });
  try {
    const aggregatedAdd = [...addedRecord, ...editedRecord.new];
    const aggregatedDelete = [...idsForUserToRoles, ...editedRecord.delete];
    const result = await postRequest('/api/adminTables', {
      screenGridId: id,
      tables: [
        {
          deleteIds: aggregatedDelete,
          insertObjects: aggregatedAdd,
          pkey: 'id',
          schema: configSchema,
          table: 'mbd_user_to_role',
        },
      ],
    });

    if (result.errors) {
      resultSet.errors.push({
        message: t('error.update_failed_following', {
          msg: result.errors[0]?.message,
        }),
      });
      resultSet.success = false;
    }
    return resultSet;
  } catch (err) {
    resultSet.errors.push({
      message: t('error.update_failed_following', {
        msg: err.message,
      }),
    });
    resultSet.success = false;
  }
  return resultSet;
}

function getEditedRowLogic({ editedRow, editedRowOriginal, userDetails }) {
  return editedRow.reduce(
    (resp, item) => {
      const ogRoleId = editedRowOriginal[item.id].role_id;
      const newRow = item.role_id.reduce((roleArr, roleId) => {
        if (!ogRoleId.includes(roleId)) {
          const newRoleRow = {
            user_id: item.user_id,
            role_id: roleId,
            created_by: userDetails.userId,
            updated_by: userDetails.userId,
            update_date: new Date().toISOString().substring(0, 19),
          };
          roleArr.push(newRoleRow);
        }
        return roleArr;
      }, []);
      const deleteRow = ogRoleId.reduce((roleArr, roleId) => {
        if (!item.role_id.includes(roleId)) {
          const deleteIds = item.user_to_role_id.map((obj) => obj[roleId]).filter((item) => item);
          roleArr.push(...deleteIds);
        }
        return roleArr;
      }, []);
      if (newRow.length) {
        resp.new = resp.new.concat(newRow);
      }
      if (deleteRow.length) {
        resp.delete = resp.delete.concat(deleteRow);
      }
      return resp;
    },
    { new: [], delete: [] },
  );
}

export default CommitHandler;
